export const Robots = [
	{
		id : 101,
		name : 'Dnyanu',
		email : 'dnyanu@gmail.com'
	},
	{
		id : 102,
		name : 'Shree',
		email : 'shree@gmail.com'
	},
	{
		id : 103,
		name : 'Bali',
		email : 'bali@gmail.com'
	},
	{
		id : 104,
		name : 'Amol',
		email : 'amol@gmail.com'
	}
];